import { css } from '@stitches/core';
import { generateClassNames } from '@supabase/auth-ui-shared';
import { createMemo } from 'solid-js';
var buttonDefaultStyles = css({
    fontFamily: '$buttonFontFamily',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    borderRadius: '$borderRadiusButton',
    fontSize: '$baseButtonSize',
    padding: '$buttonPadding',
    cursor: 'pointer',
    borderWidth: '$buttonBorderWidth',
    borderStyle: 'solid',
    width: '100%',
    transitionProperty: 'background-color',
    transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',
    transitionDuration: '100ms',
    variants: {
        color: {
            "default": {
                backgroundColor: '$defaultButtonBackground',
                color: '$defaultButtonText',
                borderColor: '$defaultButtonBorder',
                '&:hover': {
                    backgroundColor: '$defaultButtonBackgroundHover'
                }
            },
            primary: {
                backgroundColor: '$brand',
                color: '$brandButtonText',
                borderColor: '$brandAccent',
                '&:hover': {
                    backgroundColor: '$brandAccent'
                }
            }
        }
    }
});
var Button = function (props) {
    var _a, _b;
    var classNames = createMemo(function () {
        return generateClassNames('button', buttonDefaultStyles({ color: props.color }), props.appearance);
    });
    return (<button {...props} style={(_b = (_a = props.appearance) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.button} class={classNames().join(' ')} disabled={props.loading}>
      {props.icon}
      {props.children}
    </button>);
};
export { Button };
